import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PoliticPartiesService {
	public politicalParties = {};

	setPoliticalParties (politicalParties) {
		this.politicalParties = politicalParties;
	}
	
	getPoliticalParties () {
		return this.politicalParties;
	}
}